import * as yup from "yup";
import { DEFAULT_MESSAGES } from "../defaultMessages";

export const createPciSchema = yup.object({
  nombre: yup
    .string()
    .required(DEFAULT_MESSAGES.REQUIRED),
  anio_implementacion: yup
    .number()
    .required(DEFAULT_MESSAGES.REQUIRED)
    .min(1900, "El año mínimo es 1900")
    .max(2100, "El año máximo es 2100"),
  plan_estudio_id: yup.number().required(DEFAULT_MESSAGES.REQUIRED),
  institucion_id: yup.number().required(DEFAULT_MESSAGES.REQUIRED),
  estado_id: yup.number().required(DEFAULT_MESSAGES.REQUIRED),
  normativas_ids: yup.array().of(yup.number()),
});
